import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { toast } from "react-toastify";
import {
    CheckboxIcon,
    EyeIcon,
    HeartIcon,
    TrashIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { Tooltip } from "@mui/material";
import { uuid } from "uuidv4";

import { store as saleSupport } from "../../../../components/VerticalLayout/store";
import store, {
    setFranchiseDataIsUpdated,
    setIsHistoryShopsModalOpened,
    setNumberActiveMultiShop,
    setNumberArchiveMultiShop,
    setSaleSupportToBeArchived,
    setSelectedHistorySaleSupports,
    setSelectedSaleSupports,
    setShopDataIsUpdated,
    setIsLoading,
    setKey,
} from "../store";
import { setIsDataUpdated } from "@pages/Applications/Kiosk/store";

import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";

import { ConfirmationArchive } from "../ConfirmationArchive";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import ErrorToast from "@components/Common/ErrorTost";
import NProgressWrapper from "@components/Common/NProgressWrapper";
import { ID_SALE_SUPPORT_KIOSK } from "@constants/index";
import { generalConfigStore, setItemsDisable } from "@store";

export function CustomIcons({
    selectedRowData,
    isArchivedSaleSupportClicked,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const {
        numberActiveMultiShop,
        numberArchiveMultiShop,
        isHistoryShopsModalOpened,
        saleSupportData,
        shopsSaleSupportData,
        saleSupportToBeArchived,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, userID, operatorID } = useSnapshot(saleSupport);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const [saleSupportState, setSaleSupportState] = React.useState<boolean>(
        selectedRowData.selectedRow?.isActive
            ? selectedRowData.selectedRow?.isActive
            : false
    );
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    const [isArchiveSVModalOpened, setIsArchiveSVModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");

    async function ClickEventEdit() {
        let shopId = selectedRowData.selectedRow.shopId;

        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/modif-all-app-state`;
        try {
            mutate(
                apiUrl,
                await fetch(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bareer ${localStorage.getItem("jwt")}`,
                    },
                    body: JSON.stringify({
                        franchiseId: franchiseID,
                        shopId,
                        state: !selectedRowData?.selectedRow.isActive,
                    }),
                    method: "POST",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw new Error("Error in application status!");
                        }
                    })
            );
        } catch (e: any) {
            console.log(`${t("There's an error")}!`);
        }
    }
    async function handleStateChange(data: boolean) {
        setLimit(1);
        setIsLoading(true);
        let id = selectedRowData?.selectedRow.Id;
        let obj = [
            {
                userId: userID,
                shopId: [selectedRowData?.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [id]: {
                        id: id,
                        displayName:
                            selectedRowData?.selectedRow[t("Display name")],
                        tag: selectedRowData?.selectedRow.Tag,
                        support_de_vente:
                            selectedRowData?.selectedRow[t("Sale support")],
                        shopId: selectedRowData?.selectedRow.shopId,
                        isArchived: selectedRowData?.selectedRow.isArchived,
                        isActive: data,
                        isFavorite: selectedRowData.selectedRow.isFavorite,
                        advancedDisplayName:
                            selectedRowData.selectedRow.advancedDisplayName,
                    },
                },
            },
        ];

        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
        mutate(
            apiUrl,
            await fetch(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
                method: "POST",
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error) {
                        throw Error(result.message);
                    } else {
                        toast.success(
                            data === true
                                ? `${t(
                                      "Sale support has been successfully activated"
                                  )}`
                                : `${t(
                                      "Sale support has been successfully deactivated"
                                  )}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        if (
                            selectedRowData.selectedRow.Id ===
                            ID_SALE_SUPPORT_KIOSK
                        ) {
                            ClickEventEdit();
                            if (data === false) {
                                if (
                                    itemsDisable.find(
                                        (item: any) =>
                                            item.id ===
                                                selectedRowData.selectedRow
                                                    .Id &&
                                            item.shopId ===
                                                selectedRowData.selectedRow
                                                    .shopId
                                    ) === undefined
                                ) {
                                    const item = [
                                        ...JSON.parse(
                                            JSON.stringify(itemsDisable)
                                        ),
                                        {
                                            id: selectedRowData.selectedRow.Id,
                                            state: false,
                                            shopId:
                                                selectedRowData.selectedRow
                                                    .shopId,
                                        },
                                    ];
                                    setItemsDisable(item);
                                    localStorage.setItem(
                                        "itemsDisable",
                                        JSON.stringify(item)
                                    );
                                }
                            } else {
                                const item = itemsDisable.filter(
                                    (item: any) =>
                                        !(
                                            item.id ===
                                                selectedRowData.selectedRow
                                                    .Id &&
                                            item.shopId ===
                                                selectedRowData.selectedRow
                                                    .shopId
                                        )
                                );
                                setItemsDisable(item);
                                localStorage.setItem(
                                    "itemsDisable",
                                    JSON.stringify(item)
                                );
                            }
                        }
                        setKey(uuid());
                        setIsLoading(false);
                    }
                })
                .catch((error: any) => {
                    toast.error(`${t("There's an error")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setIsLoading(false);
                })
        );
    }

    async function handleActiveSaleSupport(selectedRowData: any) {
        setIsLoading(true);
        toast.dismiss();
        setLimit(1);
        let dataService = [
            {
                userId: userID,
                shopId: [selectedRowData.selectedRow.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                isShop: true,
                data: {
                    [selectedRowData.selectedRow.Id]: {
                        id: selectedRowData.selectedRow.Id,
                        displayName:
                            selectedRowData?.selectedRow[t("Display name")],
                        tag: selectedRowData?.selectedRow.Tag,
                        support_de_vente:
                            selectedRowData?.selectedRow[t("Sale support")],
                        shopId: selectedRowData?.selectedRow.shopId,
                        isActive: selectedRowData.selectedRow.isActive,
                        isArchived: false,
                        isFavorite: selectedRowData.selectedRow.isFavorite,
                        advancedDisplayName:
                            selectedRowData.selectedRow.advancedDisplayName,
                    },
                },
            },
        ];

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataService),
        };
        try {
            mutate(
                apiUrlAdd,
                await fetch(apiUrlAdd, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error("error");
                        }
                        toast.success(
                            `${t("Sale support is successfully unarchived")!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                theme: "colored",
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        setKey(uuid());
                        setIsLoading(false);
                        setIsDataUpdated!(true);
                        setShopDataIsUpdated!(true);
                        setFranchiseDataIsUpdated!(true);
                        setNumberActiveMultiShop(numberActiveMultiShop + 1);
                        setNumberArchiveMultiShop(numberArchiveMultiShop - 1);
                    })
            );
        } catch (e: any) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsLoading(false);
        }
    }

    async function handleArchiveSaleSupport(selectedRowData: any) {
        setLimit(1);
        let saleSupportUsed: any = [];
        const listOfSaleSupport = encodeURIComponent(selectedRowData.Id);
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/isSaleSupportUsed?userId=${userID}&shopId=${selectedRowData?.shopId}&franchiseId=${franchiseID}&saleSupport=${listOfSaleSupport}`;
        mutate(
            url,
            await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.saleSupportUsed.length > 0) {
                        saleSupportUsed = result.saleSupportUsed;
                        toast.error(
                            `${t(
                                "Attention, you cannot archive a used element."
                            )}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast.error(`${t("There's an error")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                })
        );

        if (saleSupportUsed.length === 0) {
            setIsArchiveSVModalOpened(true);
        }
    }
    async function handleArchiveSaleSupportShop(selectedRowData: any) {
        setIsLoading(true);
        setLimit(1);

        let dataConfig = [
            {
                userId: userID,
                shopId: [selectedRowData?.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [selectedRowData?.Id]: {
                        id: selectedRowData.Id,
                        displayName: selectedRowData[t("Display name")],
                        tag: selectedRowData.Tag,
                        support_de_vente: selectedRowData[t("Sale support")],
                        shopId: selectedRowData.shopId,
                        isActive: false,
                        isArchived: true,
                        isFavorite: selectedRowData.isFavorite,
                        advancedDisplayName:
                            selectedRowData.advancedDisplayName,
                    },
                },
            },
        ];
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataConfig),
        };
        mutate(
            apiUrl,
            await fetch(apiUrl, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.error) {
                        throw Error(result.message);
                    }
                    toast.success(
                        `${t("Sale Support is successfully archived")}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                    setKey(uuid());
                    setIsLoading(false);
                    setIsDataUpdated!(true);
                    setShopDataIsUpdated!(true);
                    setFranchiseDataIsUpdated!(true);
                    setNumberActiveMultiShop(numberActiveMultiShop - 1);
                    setNumberArchiveMultiShop(numberArchiveMultiShop + 1);
                })
                .catch((error) => {
                    toast.error(`${t("There's an error")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    setIsLoading(false);
                })
        );
    }
    async function favoriteSaleSupport() {
        setIsLoading(true);
        setLimit(1);
        toast.dismiss();
        let dataSS: any = [];
        shopsSaleSupportData.forEach((el: any) => {
            let favoriteSaleSupportData;
            el.subRows.forEach((saleSupport: any) => {
                if (
                    saleSupport.Id === selectedRowData.selectedRow.Id &&
                    saleSupport.shopId === selectedRowData.selectedRow.shopId
                ) {
                    favoriteSaleSupportData = {
                        userId: userID,
                        shopId: [selectedRowData.selectedRow.shopId],
                        franchiseId: franchiseID,
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        isShop: false,
                        data: {
                            [saleSupport.Id]: {
                                id: saleSupport.Id,
                                displayName: saleSupport[t("Display name")],
                                tag: saleSupport.Tag,
                                support_de_vente:
                                    saleSupport[t("Sale support")],
                                shopId: saleSupport.shopId,
                                isActive: saleSupport.isActive,
                                isArchived: saleSupport.isArchived,
                                isFavorite: true,
                                advancedDisplayName:
                                    saleSupport.advancedDisplayName,
                            },
                        },
                    };
                    dataSS.push(favoriteSaleSupportData);
                } else if (
                    saleSupport.Id !== selectedRowData.selectedRow.Id &&
                    saleSupport.shopId === selectedRowData.selectedRow.shopId
                ) {
                    favoriteSaleSupportData = {
                        userId: userID,
                        shopId: [selectedRowData.selectedRow.shopId],
                        franchiseId: franchiseID,
                        operatorId: operatorID,
                        uuidUser: uuidUser,
                        isShop: false,
                        data: {
                            [saleSupport.Id]: {
                                id: saleSupport.Id,
                                displayName: saleSupport[t("Display name")],
                                tag: saleSupport.Tag,
                                support_de_vente:
                                    saleSupport[t("Sale support")],
                                shopId: saleSupport.shopId,
                                isActive: saleSupport.isActive,
                                isArchived: saleSupport.isArchived,
                                isFavorite: false,
                                advancedDisplayName:
                                    saleSupport.advancedDisplayName,
                            },
                        },
                    };
                    dataSS.push(favoriteSaleSupportData);
                }
            });
        });

        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataSS),
        };
        try {
            mutate(
                apiUrlAdd,
                await fetch(apiUrlAdd, requestOptions)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error("error");
                        } else {
                            toast.success(
                                `${t(
                                    "Favorite state has been enabled successfully"
                                )}`,
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    theme: "colored",
                                    icon: (
                                        <CheckboxIcon
                                            height={25}
                                            width={25}
                                            fill="white"
                                        />
                                    ),
                                }
                            );
                            setKey(uuid());
                            setIsDataUpdated!(true);
                            setFranchiseDataIsUpdated!(true);
                            setShopDataIsUpdated(true);
                            setIsLoading(false);
                        }
                    })
            );
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsLoading(false);
        }
    }

    React.useEffect(() => {
        if (isValidateClicked === true) {
            handleArchiveSaleSupportShop(saleSupportToBeArchived);
        }
        // eslint-disable-next-line
    }, [isValidateClicked]);

    return (
        <React.Fragment>
            {selectedRowData.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isArchivedSaleSupportClicked
                                        ? ""
                                        : selectedRowData.selectedRow
                                              .isFavorite === false
                                        ? t("Enable favorite state")
                                        : t("Disable favorite state")
                                }
                            >
                                <div>
                                    <HeartIcon
                                        onClick={() => {
                                            if (
                                                selectedRowData.selectedRow
                                                    .isFavorite === false
                                            ) {
                                                if (
                                                    selectedRowData.selectedRow
                                                        .isActive === false
                                                ) {
                                                    ErrorToast(
                                                        t(
                                                            "Please note, you cannot activate the favorite state for a disabled sale support"
                                                        )
                                                    );
                                                } else {
                                                    favoriteSaleSupport();
                                                }
                                            }
                                        }}
                                        height={25}
                                        width={25}
                                        name="heart"
                                        fill={
                                            selectedRowData.selectedRow
                                                .isFavorite
                                                ? "red"
                                                : "black"
                                        }
                                        className={`${classnames(
                                            "pointer__clz",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedSaleSupportClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={
                                    isArchivedSaleSupportClicked
                                        ? ""
                                        : saleSupportState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={saleSupportState}
                                        onChange={async (e: boolean) => {
                                            if (
                                                selectedRowData.selectedRow
                                                    .isFavorite &&
                                                selectedRowData.selectedRow
                                                    .isActive
                                            ) {
                                                ErrorToast(
                                                    t(
                                                        "Please note, you cannot deactivate a favorite sale support"
                                                    )
                                                );
                                            } else {
                                                setMessage(
                                                    saleSupportState
                                                        ? t(
                                                              "Caution, the Sale support may be used by other modules.\n Would you like to confirm the deactivation of the selected Sale support?"
                                                          )
                                                        : t(
                                                              "Would you like to confirm the activation of the selected Sale support?"
                                                          )
                                                );
                                                setYesFunction(() => {
                                                    setSaleSupportState(
                                                        !saleSupportState
                                                    );
                                                    handleStateChange(e);
                                                });

                                                setActivationDeactivationMessageModalOpened(
                                                    true
                                                );
                                            }
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "pointer__clz ml-1 cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz":
                                                    isArchivedSaleSupportClicked ||
                                                    isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>

                            {!isArchivedSaleSupportClicked ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={() => {
                                                if (
                                                    selectedRowData.selectedRow
                                                        ?.isFavorite === true
                                                ) {
                                                    setIsLoading(false);
                                                    ErrorToast(
                                                        t(
                                                            `Please note, you cannot archive a favorite sales support`
                                                        )
                                                    );
                                                } else {
                                                    setSaleSupportToBeArchived(
                                                        selectedRowData.selectedRow
                                                    );
                                                    handleArchiveSaleSupport(
                                                        selectedRowData?.selectedRow
                                                    );
                                                }
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "ml-1 cmn_icn_BTarchived",
                                                {
                                                    "not-allowed-icon__clz": isLoading,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        saleSupportData.find(
                                            (el: any) =>
                                                el.Id ===
                                                selectedRowData.selectedRow.Id
                                        ) !== undefined
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                                handleActiveSaleSupport(
                                                    selectedRowData
                                                );
                                            }}
                                            className={`${classnames(
                                                "pointer__clz ml-1 cmn_icn_BTunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isLoading ||
                                                        saleSupportData.find(
                                                            (el: any) =>
                                                                el.Id ===
                                                                selectedRowData
                                                                    .selectedRow
                                                                    .Id
                                                        ) !== undefined,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                className="pointer__clz ml-1 cmn_icn_BThistory"
                                onClick={() => {
                                    setIsHistoryShopsModalOpened(
                                        !isHistoryShopsModalOpened
                                    );
                                    setSelectedHistorySaleSupports(
                                        selectedRowData.selectedRow
                                    );
                                    setSelectedSaleSupports([
                                        {
                                            [selectedRowData.selectedRow
                                                .shopId]:
                                                selectedRowData.selectedRow.Id,
                                        },
                                    ]);
                                }}
                                height={25}
                                width={25}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
            {isArchiveSVModalOpened ? (
                <ConfirmationArchive
                    isArchiveSVModalOpened={isArchiveSVModalOpened}
                    setIsArchiveSVModalOpened={setIsArchiveSVModalOpened}
                    setIsValidateClicked={setIsValidateClicked}
                />
            ) : null}
            <NProgressWrapper isLoading={isLoading} />
        </React.Fragment>
    );
}
